import {SpinePlayer} from "../../core/displayObject/SpinePlayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Layers} from "./KarenLayers";
import {TimelineLite, Linear} from "gsap";

export class KarenSplashOverlayView extends PIXI.Container {
    private splash: SpinePlayer;
    private _dimmer: PIXI.Graphics;

    constructor() {
        super();
        this.init();
    }

    public init(): void {
        this.splash = new SpinePlayer("splashes_banner", false);
        this.splash.alpha = 0;
        this.splash.visible = false;
        this.position.set(370, 440);
        this.createDimmer();
        this.addChild(this.splash);
        NolimitApplication.getLayerByName(Layers.SPLASH_VIEW)?.addChild(this);
    }

    public playAnimation(animName: string): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this.splash.visible = true;
            this.splash.alpha = 1;
            this._dimmer.visible = true;
            this._dimmer.alpha = 1;
        });
        tl.add(this.splash.play({name: animName, loop: false, showOnEnd: true}));
        tl.to([this.splash, this._dimmer], {alpha: 0, duration: 0.3, ease: Linear.easeInOut});
        return tl;
    }

    public stopAnimation() {
        this.splash.alpha = 0;
        this.splash.visible = false;
        this._dimmer.alpha = 0;
        this._dimmer.visible = false;
    }

    private createDimmer(): void {
        this._dimmer = new PIXI.Graphics();
        this._dimmer.beginFill(0x0000000, 0.2);
        this._dimmer.drawRect(-NolimitApplication.screenBounds.width, -NolimitApplication.screenBounds.height, NolimitApplication.screenBounds.width * 2, NolimitApplication.screenBounds.height * 2);
        this._dimmer.endFill();
        this._dimmer.visible = false;
        this._dimmer.alpha = 0;
        this.addChild(this._dimmer);
    }
}
